/**
 * @generated SignedSource<<d5654070ecac5c372178f9cf5778a001>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WizardFooter_Node$data = {
  readonly __typename: "TimeSlot";
  readonly agenda: {
    readonly id: string;
  };
  readonly id: string;
  readonly lockedUntil: string | null | undefined;
  readonly " $fragmentType": "WizardFooter_Node";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "WizardFooter_Node";
};
export type WizardFooter_Node$key = {
  readonly " $data"?: WizardFooter_Node$data;
  readonly " $fragmentSpreads": FragmentRefs<"WizardFooter_Node">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WizardFooter_Node",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lockedUntil",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "TimeSlot",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "fa0da3c9da15d051e04d468e5c21d301";

export default node;
